"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.CLICKABLE = exports.ICON_SVG = exports.ICON_CONTAINER = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty")),
    _cxs = _interopRequireDefault(require("cxs")),
    _vars = require("../../../common/styles/vars");

function ownKeys(a, b) {
  var c = Object.keys(a);

  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(a);
    b && (d = d.filter(function (b) {
      return Object.getOwnPropertyDescriptor(a, b).enumerable;
    })), c.push.apply(c, d);
  }

  return c;
}

function _objectSpread(a) {
  for (var b, c = 1; c < arguments.length; c++) {
    b = null == arguments[c] ? {} : arguments[c], c % 2 ? ownKeys(Object(b), !0).forEach(function (c) {
      (0, _defineProperty2["default"])(a, c, b[c]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(b)) : ownKeys(Object(b)).forEach(function (c) {
      Object.defineProperty(a, c, Object.getOwnPropertyDescriptor(b, c));
    });
  }

  return a;
}

var ICON_COLOUR = function ICON_COLOUR(a) {
  var b = a.color,
      c = a.requiresStroke;
  return {
    fill: _vars.FLATTENED_COLOURS[b],
    stroke: c ? _vars.FLATTENED_COLOURS[b] : void 0
  };
};

function getColourStyles(a) {
  var b = a.color,
      c = a.requiresStroke,
      d = ICON_COLOUR({
    color: b,
    requiresStroke: c
  });
  return {
    " path": d,
    " rect": d,
    " polygon": d
  };
}

var ICON_CONTAINER = function ICON_CONTAINER(a) {
  var b = a.size,
      c = a.hoverColor,
      d = a.ignoresColour,
      e = a.requiresStroke;
  return (0, _cxs["default"])(_objectSpread({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "".concat(b, "px"),
    minWidth: "".concat(b, "px")
  }, c && !d ? {
    ":hover": {
      " > *:first-child": _objectSpread({}, getColourStyles({
        color: c,
        requiresStroke: e
      }))
    }
  } : {}, {
    " div": {
      display: "inline-flex",
      alignItems: "center"
    }
  }));
};

exports.ICON_CONTAINER = ICON_CONTAINER;

var ICON_SVG = function ICON_SVG(a) {
  var b = a.color,
      c = a.requiresStroke,
      d = a.ignoresColour,
      e = a.size,
      f = {
    height: "".concat(e, "px"),
    width: "".concat(e, "px")
  },
      g = _objectSpread({}, f, {
    " > svg": _objectSpread({}, f, {
      display: "flex"
    })
  });

  return d ? (0, _cxs["default"])(g) : (0, _cxs["default"])(_objectSpread({}, getColourStyles({
    color: b,
    requiresStroke: c
  }), {}, g));
};

exports.ICON_SVG = ICON_SVG;
var CLICKABLE = (0, _cxs["default"])({
  cursor: "pointer"
});
exports.CLICKABLE = CLICKABLE;